/*
  Flash sale gate.

  A marketing gate, not real security: the check runs entirely in the browser and
  the unlock flag lives in localStorage, so a determined visitor can bypass it.
  Only the SHA-256 of the password is written to the page so the plain value is
  not readable in the page source.
*/
(function () {
  const ready = (callback) => {
    if (document.readyState !== 'loading') {
      callback();
      return;
    }
    document.addEventListener('DOMContentLoaded', callback);
  };

  const sha256 = async (value) => {
    if (!window.crypto || !window.crypto.subtle) return null;

    const bytes = new TextEncoder().encode(value);
    const digest = await window.crypto.subtle.digest('SHA-256', bytes);

    return Array.from(new Uint8Array(digest))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  };

  const setUnlocked = (storageKey) => {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Private mode or blocked storage: the redirect still happens, but the
      // guard will ask for the password again on the next visit.
    }
  };

  const initToggle = (form) => {
    const input = form.querySelector('[data-gate-input]');
    const toggle = form.querySelector('[data-gate-toggle]');
    if (!input || !toggle) return;

    toggle.addEventListener('click', () => {
      const isHidden = input.type === 'password';
      input.type = isHidden ? 'text' : 'password';
      toggle.setAttribute('aria-pressed', String(isHidden));
      input.focus();
    });
  };

  const initForm = (form) => {
    const input = form.querySelector('[data-gate-input]');
    const error = form.querySelector('[data-gate-error]');
    const submitButton = form.querySelector('[data-gate-submit]');
    const expectedHashes = (form.dataset.accessHash || '')
      .split(',')
      .map((hash) => hash.trim())
      .filter(Boolean);
    const storageKey = form.dataset.storageKey || 'flash-sale-access';
    const redirectUrl = form.dataset.redirectUrl;

    initToggle(form);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (error) error.hidden = true;

      const value = (input.value || '').trim().toLowerCase();
      if (!value) return;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      const hash = await sha256(value);

      if (hash === null || !expectedHashes.includes(hash)) {
        if (error) error.hidden = false;
        input.select();
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
        return;
      }

      // Left busy/disabled: the page is about to navigate away.
      setUnlocked(storageKey);
      window.location.assign(redirectUrl || '/');
    });
  };

  ready(() => {
    document.querySelectorAll('[data-flash-sale-gate]').forEach(initForm);
  });
})();
